export const SET_CLIENT_TICKET_DATA = "SET_CLIENT_TICKET_DATA";
export const RESET_CLIENT_TICKET = "RESET_CLIENT_TICKET";

export const setClientTicketData = (payload) => ({
  type: SET_CLIENT_TICKET_DATA,
  payload,
});

export const resetClientTicket = () => ({
  type: RESET_CLIENT_TICKET,
});
